import {
  FormLabel,
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
} from "@mui/material";

import { TypedOption } from "api/common/types/common.types";
import { useFieldContext } from "components/Forms/AppForm";

import ErrorMessage from "../../helpers/ErrorMessage";

interface BooleanRadioButtonProps {
  options: TypedOption<boolean>[];
  label: string;
  isHorizontal?: boolean;
  required?: boolean;
  onChange?: (_value: boolean) => void;
}

const BooleanRadioButton = ({
  options = [],
  label,
  isHorizontal = false,
  onChange,
  required = false,
}: BooleanRadioButtonProps) => {
  const field = useFieldContext<boolean>();

  return (
    <FormControl>
      <FormLabel
        id={`${label}-radio-buttons-group-label`}
        color="primary"
        required={required}
      >
        {label}
      </FormLabel>
      <RadioGroup
        aria-labelledby={`${label}-radio-buttons-group-label`}
        value={field.state.value}
        name={`${label}-radio-buttons-group`}
        onChange={(e) => {
          field.handleChange(e.target.value === "true");
          onChange?.(e.target.value === "true");
        }}
        row={isHorizontal}
      >
        {options.map((option) => (
          <FormControlLabel
            key={option.label}
            value={String(option.value)}
            control={<Radio />}
            label={option.label}
          />
        ))}
      </RadioGroup>
      <ErrorMessage />
    </FormControl>
  );
};
export default BooleanRadioButton;
